import { VCardText } from 'vuetify/lib/components/VCard';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ax-dialog',{ref:"dialog",attrs:{"mode":"listitem","title":_vm.group.name,"linkText":"Group details","subtitle":`${_vm.group.count} wells`,"icon":"mdi-information-outline","tooltip":"Group details","size":"medium"}},[_c('template',{slot:"content"},[_c(VCardText,[_c('pre',[_vm._v(_vm._s(_vm.group))])])],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }